// extracted by mini-css-extract-plugin
export default {"list":"fancy-text-font-option-module__list--I3myp"};